import { handleErrors, simpleGetRequest } from "../../../shared/src/API/baseAPI";
import { TabNavigator } from "../../../shared/src/components/Tabulator/TabNavigator";
import { createUserCard } from "../../../shared/src/components/UserCard/user-info";
import { loadImage } from "../../../shared/src/UIController/imageloader";
import { showAlert } from "../../../shared/src/Util/alerts";
import { getCurrentUser, registerTriggerFunction } from "../../../shared/src/Util/helper";

const monthlyTab = document.getElementById('monthlyTab');
const totalTab = document.getElementById('allTimeTab');
new TabNavigator([monthlyTab, totalTab], null, switchTab, {forced: false});
let state = 0;

function switchTab(s) {
    if (s == undefined) s = state;

    state = s
    clearTab();
    document.getElementById('loadingState').classList.remove('hidden');
    if (state === 1 || state === '1') {
        document.getElementById('leaderboardTitle').innerText = t('leader.allTime');
        simpleGetRequest('/api/v1/rewards/alltime', 'activityLoader', handleRewardsTable)
    } else {
        document.getElementById('leaderboardTitle').innerText = t('leader.monthly');
        simpleGetRequest('/api/v1/rewards/', 'activityLoader', handleRewardsTable)
    }
}

function clearTab() {
    document.getElementById('emptyState').classList.add('hidden');
    document.getElementById('leaderboardBody').innerHTML = '';
}

function handleRewardsTable(res) {
    document.getElementById('loadingState').classList.add('hidden');

    if (res.error) {
        handleErrors(res);
        return;
    }

    updateLastUpdatedTime();

    if (!Array.isArray(res) || res.length == 0) {
        document.getElementById('emptyState').classList.remove('hidden');
        return;
    }

    res.forEach((entry, index) => {
        const row = createLeaderboardRow(entry, index);
        leaderboardBody.appendChild(row);
        const wrapper = document.getElementById('leaderboard-entry-' + entry.id);
        createUserCard(wrapper, entry, {
            position: 'bottom'
        });
    });
}

function createLeaderboardRow(entry, index) {
    const rank = index + 1;
    const points = state == 0? entry.monthlyPoints : entry.totalPoints;

    const row = document.createElement('tr');
    const isTopThree = rank <= 3;
    
    if (isTopThree) {
        row.className = 'bg-gradient-to-r from-yellow-50 to-transparent dark:from-yellow-900/20';
    }
    
    const rankDisplay = getRankDisplay(rank);
    const badge = getRankBadge(rank);

    row.innerHTML = `
        <td class="font-bold ${isTopThree ? 'text-lg' : ''}">${rankDisplay}</td>
        <td class="relative items-center" id="leaderboard-entry-${entry.id}">
        </td>
        <td class="text-right">
            <div class="font-bold text-lg ${isTopThree ? 'text-primary' : ''}">${points}</div>
        </td>
    `;
    
    return row;
}

function getRankDisplay(rank) {
    switch(rank) {
        case 1: return '🥇 1';
        case 2: return '🥈 2';
        case 3: return '🥉 3';
        default: return `#${rank}`;
    }
}

function getRankBadge(rank) {
    switch(rank) {
        case 1: return `<div class="badge badge-warning gap-1"><i class="fas fa-crown"></i> ${t('leader.champion')}</div>`;
        case 2: return `<div class="badge badge-info gap-1"><i class="fas fa-medal"></i> ${t('leader.runnerup')}</div>`;
        case 3: return `<div class="badge badge-success gap-1"><i class="fas fa-award"></i> ${t('leader.thirdplace')}</div>`;
        default: return '';
    }
}

function updateLastUpdatedTime() {
    const now = new Date();
    const timeString = now.toLocaleTimeString('en-US', { 
      hour: '2-digit', 
      minute: '2-digit',
      hour12: false 
    });
    document.getElementById('lastUpdated').textContent = timeString;
}

// Animation for point updates
function animatePointUpdate(elementId, newValue) {
    const element = document.getElementById(elementId);
    if (!element) return;
    
    const currentValue = parseInt(element.textContent) || 0;
    const increment = newValue > currentValue;
    
    element.style.transform = 'scale(1.2)';
    element.style.color = increment ? '#10b981' : '#ef4444';
    
    setTimeout(() => {
        element.textContent = newValue.toLocaleString();
        element.style.transform = 'scale(1)';
        
        setTimeout(() => {
            element.style.color = '';
        }, 500);
    }, 200);
}

registerTriggerFunction('winnerModal', showWinnerAnnouncement);

// Show winner announcement
function showWinnerAnnouncement(winner = {
    username: 'Deleted User',
    id: -1,
}) {
    document.getElementById('winnerName').textContent = winner.username;
    document.getElementById('winnerName1').textContent = winner.username;
    loadImage(winner.avatar, document.getElementById('winnerAvatar'), document.getElementById('winnerAvatarWrapper'), { fallbackUrl: '/img/account-placeholder.png' })

    const user = getCurrentUser();
    if (user && user.id == winner.id) {
        document.getElementById('claimReward').classList.remove('hidden');
    } else {
        document.getElementById('acknowledge').classList.remove('hidden');
    }
}

export function claimReward() {
    showAlert('This feature is coming soon.', 'warning');
}

// Intersection Observer for animations
const observerOptions = {
    threshold: 0.1,
    rootMargin: '50px'
};

const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        entry.target.style.opacity = '1';
        entry.target.style.transform = 'translateY(0)';
    }
});
}, observerOptions);

// Observe cards for animation
document.querySelectorAll('.card').forEach(card => {
    card.style.opacity = '0';
    card.style.transform = 'translateY(20px)';
    card.style.transition = 'all 0.6s ease-out';
    observer.observe(card);
});

let clickCount = 0;
export function confetti() {
    clickCount++;
    window.confetti({
        disableForReducedMotion: true,
        particleCount: clickCount > 10? (clickCount * 10 < 500? clickCount * 10 : 300) : 50
    });

    if (clickCount == 50) {
        showAlert("That's a pretty decent device, you got there!", 'info');
    } else if (clickCount == 100) {
        showAlert('Do you want an achievement for this?');
    }
}